import { Injectable } from '@angular/core';
import { environment } from './environments/environment';

@Injectable({
  providedIn: 'root',
})
export class StaticService {
  static baseUrl = `${environment.apiUrl}`;

  auth = {
    login: StaticService.baseUrl + 'login',
    logout: StaticService.baseUrl + 'logout',
    refresh: StaticService.baseUrl + 'token/refresh',
    forgotPassword: StaticService.baseUrl + 'forgot-password',
    reset: StaticService.baseUrl + 'forgot-password-confirm?uid=',
    resetEmail: StaticService.baseUrl + 'change-email-confirm?uid=',
  };
  user = {
    user: StaticService.baseUrl + 'user',
    post: StaticService.baseUrl + 'user',
    getOne: StaticService.baseUrl + 'Account/GetUser/GetUser',
    update: StaticService.baseUrl + 'Account/Update',
    user_detail: StaticService.baseUrl + 'user-details',
  };
  role = {
    role: StaticService.baseUrl + 'role',
  };
  product = {
    product: StaticService.baseUrl + 'product',
    getOne: StaticService.baseUrl + 'Product/GetProductById/Get',
    put: StaticService.baseUrl + 'Product/Edit',
    supplier: StaticService.baseUrl + 'product/supplier',
    xero: StaticService.baseUrl + 'product/xero',
  };
  category = {
    get: StaticService.baseUrl + 'product/category',
  };
  unitOfMeasure = {
    get: StaticService.baseUrl + 'product/unit-of-measure',
  };
  brand = {
    get: StaticService.baseUrl + 'product/brand',
  };
  country = {
    get: StaticService.baseUrl + 'country',
  };
  order = {
    order: StaticService.baseUrl + 'order',
    status: StaticService.baseUrl + 'order-status',
    statusTransition: StaticService.baseUrl + 'order-status-transition',
    get: StaticService.baseUrl + 'UnitOfMeasure/GetUnitOfMeasures',
    post: StaticService.baseUrl + 'Order/AddOrder',
    getOnebyUser: StaticService.baseUrl + 'Order/GetOrderByUser',
    getOnebyId: StaticService.baseUrl + 'Order/GetOrder',
    getOneByShop: StaticService.baseUrl + 'Order/GetOrderByShop',
    count: StaticService.baseUrl + 'dashboard/all-counts',
    last_week: StaticService.baseUrl + 'dashboard/order-last-week',
    last_month: StaticService.baseUrl + 'dashboard/order-last-month',
  };
  shop = {
    shop: StaticService.baseUrl + 'shop',
    getOne: StaticService.baseUrl + 'Shop/Get/Get',
    post: StaticService.baseUrl + 'shop',
    put: StaticService.baseUrl + 'Shop/Update',
    tool: StaticService.baseUrl + 'tool/shop',
    xero: StaticService.baseUrl + 'shop/xero',
    last_week: StaticService.baseUrl + 'dashboard/shop-last-week',
    last_month: StaticService.baseUrl + 'dashboard/shop-last-month',
    shop_performance: StaticService.baseUrl + 'dashboard/shop-performance',
  };
  template = {
    template: StaticService.baseUrl + 'template',
    get: StaticService.baseUrl + 'OrderTemplate/GetAll',
    post: StaticService.baseUrl + 'OrderTemplate/Add',
    getByShop: StaticService.baseUrl + 'OrderTemplate/GetOrderByShop',
    getOne: StaticService.baseUrl + 'OrderTemplate/GetById',
    default: StaticService.baseUrl + 'template/default',
  };
  state = {
    get: StaticService.baseUrl + 'state',
  };
  common = {
    brand: StaticService.baseUrl + 'product/brand',
    country: StaticService.baseUrl + 'country',
  };
  integration = {
    xero: StaticService.baseUrl + 'integration/xero',
    tenant: StaticService.baseUrl + 'xero/tenant',
    account: StaticService.baseUrl + 'xero/accounts',
  };
  tenants = StaticService.baseUrl + 'tenants';
}
